<script>
import PageLayout from '../Components/UI/PageLayout.vue'
import MainContainer from '../Components/UI/Content/MainContainer.vue'
import BlockContent from '../Components/UI/Content/BlockContent.vue'
import CardContent from '../Components/UI/Content/CardContent.vue'
import DataTable from '../Components/UI/Table/DataTable.vue'
import TableDownloadButton from '../Components/UI/Table/TableDownloadButton.vue'
import mixinComponent from '../Mixins/mixinComponent'
import { globalVariablesMixin } from '../Mixins/global'
import { isTheme } from '../Utils/isTheme.js'

export default {
  components: { TableDownloadButton, DataTable, CardContent, BlockContent, MainContainer, PageLayout },
  mixins: [mixinComponent, globalVariablesMixin],
  data() {
    return {
      mainOptionsList: {
        ALL: 'simulation.list.status.ALL',
        CONTRACT: 'menu.myContracts',
        PORTFOLIO: 'menu.myPortfolio',
      },
      subOptionsListContracts: {
        ALL: 'contract.list.type.status.ALL',
        CREATED: 'contract.list.type.status.CREATED',
        PENDING: 'contract.list.type.status.PENDING',
        CLIENT_SIGNED: 'contract.list.type.status.CLIENT_SIGNED',
        OTHER: 'contract.list.type.status.OTHER',
      },
      subOptionsListPortfolio: {
        ALL: 'contract.list.type.status.ALL',
        PAID: 'contract.list.type.status.PAID',
        FINISH: 'contract.list.type.status.FINISH',
        ARCHIVE: 'contract.list.type.status.ARCHIVE',
      },
      menu: 'equipements-index',
      mainFilter: 'ALL',
      subFilter: 'ALL',
      allContracts: [
        'CREATED',
        'VALIDATED',
        'STUDY',
        'STUDIED',
        'PENDING',
        'CLIENT_SIGNED',
        'COMPANY_SIGNED',
        'CHECKED',
        'ORDERED',
        'WAITING',
        'DELIVERED',
        'COMPLETE',
      ],
      allPortfolio: ['PAID', 'FINISH', 'ENDED', 'CLOSED', 'PROLONGATION', 'CESSION'],
    }
  },

  watch: {
    mainFilter(val, oldVal) {
      if (val !== oldVal) {
        this.$refs.listeEquipements.renderDataTable()
      }
    },
    subFilter(val, oldVal) {
      if (val !== oldVal) {
        this.$refs.listeEquipements.renderDataTable()
      }
    },
  },

  computed: {
    columns() {
      switch (this.conf.theme_dir) {
        case 'ciscar':
          return [
            { name: 'id', title: this.$t('equipment.fields.id.label') },
            {
              name: 'contractCreatedAt',
              title: this.$t('equipment.fields.contractCreatedAt.label'),
              formatter: 'date',
            },
            {
              name: 'contractNumber',
              title: this.$t('equipment.fields.contractNumber.label'),
              formatter: 'context',
              options: { renderType: 'contracts', renderId: 'contractId' },
            },
            { name: 'codeComptableClient', title: this.$t('equipment.fields.codeComptableClient.label') },
            { name: 'supplierName', title: this.$t('equipment.fields.supplier.title') },
            { name: 'companySalesman', title: this.$t('equipment.fields.companySalesman.label') },
            { name: 'equipmentTypeName', title: this.$t('equipment.fields.equipmentType.label') },
            { name: 'productTypeName', title: this.$t('equipment.fields.productTypeName.label') },
            { name: 'productRef', title: this.$t('equipment.fields.productRef.label') },
            { name: 'brand', title: this.$t('equipment.fields.brand.label') },
            { name: 'model', title: this.$t('equipment.fields.model.label') },
            {
              name: 'serialNumber',
              title: this.$t('equipment.fields.serialNumber.label'),
              style: { className: 'col-1' },
              formatter: 'custom',
              options: { renderer: this.renderSerialNumber },
            },
            { name: 'amount', title: this.$t('equipment.fields.amount.label') },
            { name: 'rent', title: this.$t('equipment.fields.rent.label') },
            { name: 'duration', title: this.$t('equipment.fields.duration.label') },
            {
              name: 'contractStatus',
              title: this.$t('equipment.fields.contractStatus.label'),
              formatter: 'status',
              options: { renderType: 'contract' },
            },
            {
              name: 'equipmentStatus',
              title: this.$t('equipment.fields.equipmentStatus.label'),
              formatter: 'status',
              options: { renderType: 'equipment' },
            },
            { name: 'esign', title: this.$t('equipment.fields.esign.label'), formatter: 'boolean' },
            { name: 'formerContractNumber', title: this.$t('equipment.fields.formerContractNumber.label') },
            { name: 'deliveryAddress', title: this.$t('equipment.fields.deliveryAdress.label') },
            { name: 'purchaseOrderNumber', title: this.$t('equipment.fields.purchaseOrderNumber.label') },
            { name: 'comment', title: this.$t('equipment.fields.comment.label') },
          ]
        default:
          return [
            { data: 'id', displayable: false },
            {
              name: 'contractNumber',
              title: this.$t('equipment.fields.contractNumber.label'),
              formatter: 'context',
              options: { renderType: 'contracts', renderId: 'contractId' },
            },
            { name: 'equipmentTypeName', title: this.$t('equipment.fields.equipmentType.label') },
            { name: 'name', title: this.$t('equipment.fields.equipment.label') },
            {
              name: 'serialNumber',
              title: this.$t('equipment.fields.serialNumber.label'),
              style: { className: 'col-1' },
              formatter: 'custom',
              options: { renderer: this.renderSerialNumber },
            },
            { name: 'condition', title: this.$t('equipment.fields.condition.label') },
            { name: 'supplierName', title: this.$t('equipment.fields.supplier.title') },
            { name: 'duration', title: this.$t('equipment.fields.duration.label') },
            { name: 'contractStartAt', title: this.$t('contract.information.startDate'), formatter: 'date' },
            { name: 'contractEndAt', title: this.$t('contract.information.endDate'), formatter: 'date' },
            {
              name: 'contractStatus',
              title: this.$t('contract.information.status'),
              formatter: 'status',
              options: { renderType: 'contract' },
              style: { className: 'text-center' },
            },
            { name: 'plate', title: this.$t('equipment.fields.plate.label'), displayable: isTheme('abflm') },
          ]
      }
    },
    urlEquipements() {
      let statuses = this.getStatusFilters()
      if (!statuses) {
        return 'equipments'
      }
      statuses = statuses.join(',')
      return 'equipments?statuses=' + statuses
    },
  },

  methods: {
    renderSerialNumber(serialNumber) {
      const limit = 25
      const fullSerialNumber = (serialNumber ?? '').toString().trim()
      const displaySerialNumber =
        fullSerialNumber.length > limit ? fullSerialNumber.slice(0, limit) + '…' : fullSerialNumber

      const element = document.createElement('span')
      element.title = fullSerialNumber
      element.textContent = displaySerialNumber

      return element.outerHTML
    },
    getMainFilter(val) {
      this.mainFilter = val
    },
    getSubFilter(val) {
      this.subFilter = val
    },
    setMainActive(value) {
      this.mainFilter = value
      this.subFilter = 'ALL'
    },
    setSubActive(value) {
      this.subFilter = value
    },
    getMainActiveClass(value) {
      if (value === this.mainFilter) {
        return 'sub-active'
      }
    },
    getSubActiveClass(value) {
      if (value === this.subFilter) {
        return 'sub-active'
      }
    },
    async getEquipments(callback, { page, limit, search, sort = [] }) {
      const searchParams = new URLSearchParams()
      searchParams.set('page', page)
      searchParams.set('limit', limit)
      for (const { field, order } of sort) {
        searchParams.set(`sort[${field}]`, order)
      }
      if (!!search) {
        searchParams.set('q', search)
      }

      const statuses = this.getStatusFilters()
      statuses.forEach((status) => {
        searchParams.append('statuses[]', status)
      })

      const { items: equipments, total } = await this.getJSON(`v2/equipments?${searchParams.toString()}`)
      callback({ data: equipments, recordsTotal: total, recordsFiltered: total })
    },
    getStatusFilters() {
      /** Note : les status 'QUOTATION_CANCELED' et 'CANCELED' ne sont jamais affichés */
      let all = this.allContracts.concat(this.allPortfolio)
      switch (this.mainFilter) {
        case 'ALL':
          return all
        case 'CONTRACT':
          switch (this.subFilter) {
            case 'ALL':
              return this.allContracts
            case 'CREATED':
              return ['CREATED']
            case 'PENDING':
              return ['VALIDATED', 'STUDY', 'STUDIED', 'PENDING']
            case 'CLIENT_SIGNED':
              return ['CLIENT_SIGNED', 'COMPANY_SIGNED', 'CHECKED', 'ORDERED', 'WAITING']
            case 'OTHER':
              return ['DELIVERED', 'COMPLETE']
          }
          break
        case 'PORTFOLIO':
          switch (this.subFilter) {
            case 'ALL':
              return this.allPortfolio
            case 'PAID':
              return ['PAID']
            case 'FINISH':
              return ['FINISH']
            case 'ARCHIVE':
              return ['ENDED', 'CLOSED', 'PROLONGATION', 'CESSION']
          }
          break
      }
      return null
    },
    async download() {
      this.toast(this.$t('home.export.generating'))

      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hours = date.getHours()
      var minutes = date.getMinutes()
      var seconds = date.getSeconds()

      let formatDate = year + '-' + month + '-' + day + '-' + hours + '-' + minutes + '-' + seconds

      let statuses = this.getStatusFilters()
      await this.downloadFile(`equipments/export?statuses=${statuses.join(',')}`, `Equipments-${formatDate}.xlsx`)

      this.toast(this.$t('home.export.sucess'))
    },
  },
}
</script>
<template>
  <PageLayout menu="equipements-index">
    <MainContainer title-t="menu.myEquipments">
      <BlockContent>
        <CardContent>
          <div
            class="d-flex justify-content-center align-items-center"
            style="padding-top: 1.25em; padding-bottom: 1.25em"
          >
            <div class="d-flex">
              <div>
                <div class="submenu-link">
                  <span
                    v-for="(value, key) in mainOptionsList"
                    @click="setMainActive(key)"
                    v-t="value"
                    :class="getMainActiveClass(key)"
                  ></span>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-center submenu-left-btns">
              <TableDownloadButton @download="download"> </TableDownloadButton>
            </div>
          </div>
          <div v-if="mainFilter === 'CONTRACT'" class="container filter-submenu">
            <div class="submenu-link">
              <span
                v-for="(value, key) in subOptionsListContracts"
                @click="setSubActive(key)"
                v-t="value"
                :class="getSubActiveClass(key)"
              ></span>
            </div>
          </div>
          <div v-if="mainFilter === 'PORTFOLIO'" class="container filter-submenu">
            <div class="submenu-link">
              <span
                v-for="(value, key) in subOptionsListPortfolio"
                @click="setSubActive(key)"
                v-t="value"
                :class="getSubActiveClass(key)"
              ></span>
            </div>
          </div>
        </CardContent>
        <CardContent>
          <DataTable
            ref="listeEquipements"
            id="listeEquipements"
            :columns="columns"
            :fetch="getEquipments"
            :order="[[0, 'desc']]"
            pagination-mode="server"
          />
        </CardContent>
      </BlockContent>
    </MainContainer>
  </PageLayout>
</template>
